<pbc-filter [config]="TemplatesFilterConfig" [filter]="templates.filter$ | async" (filterChange)="templates.filter$.next($event)"></pbc-filter>
